/**
 * Lap pre-exclusion + Filter Laps bar banding.
 *
 * Tuning any value here: edit → `npm run build` in src/PitBrain.Shared →
 * restart/rebuild the clients.
 */

/**
 * Unit: % of the session's MEDIAN lap time. Default: 1.3.
 * A lap SLOWER than the median by more than this % is pre-deselected in the
 * Filter Laps drawer (slow side only — fast laps are never excluded; the
 * comparison is strictly-greater, verified at the exact boundary by tests —
 * do not "improve" the formulation). Scales with lap length: a 1:00 median
 * filters at ≈ +0.8 s, a 2:00 median at ≈ +1.6 s.
 * LOWER this to pre-deselect more marginal laps; RAISE it if genuine push
 * laps keep getting pre-deselected.
 */
export const SLOW_LAP_EXCLUSION_PCT = 1.3

/**
 * Unit: % of the included-laps MEAN lap time. Default: 3.3.
 * Bands the drawer's live delta bars: red beyond the full window, amber
 * beyond LAP_DELTA_AMBER_FRACTION of it, green inside.
 * Deliberately INDEPENDENT of SLOW_LAP_EXCLUSION_PCT (owner, pass 24):
 * tuning exclusion must not re-colour the bars.
 * LOWER this to make bars go amber/red for smaller deltas; RAISE it to be
 * more forgiving.
 */
export const LAP_DELTA_BAND_PCT = 3.3

/**
 * Unit: fraction of the banding window, in (0, 1). Default: 0.5.
 * Amber starts at this fraction of the window; red at the full window.
 * RAISE toward 1 to delay amber until nearly red; LOWER toward 0 to show
 * amber earlier.
 */
export const LAP_DELTA_AMBER_FRACTION = 0.5
